<template>
  <div id="imageSelect">

    <div class="image-section">

      <v-icon class="image-icon" :error="images.length > max">mdi-camera</v-icon>

      <!-- IMAGES -->
      <div class="image-label" :class="{invalid: this.images.length > max}">Select up to {{ max }} image{{ max === 1 ? '' : 's' }} to upload.</div>

        <div class="buttons">
          <v-btn v-if="cordova" class="button" block @click="phonegapCamera" large :disabled="images.length >= max">
            <v-icon class="icon" style="opacity: .54;">mdi-camera</v-icon><span style="margin-left: 8px">Take Photo</span>
          </v-btn>
          <v-btn v-if="android" class="button" block @click="phonegapLibrary" large :disabled="images.length >= max">
            <v-icon class="icon" style="opacity: .54;">mdi-image-multiple</v-icon><span style="margin-left: 8px">Select Images</span>
          </v-btn>
          <v-btn v-if="!android" block @click="triggerImageUpload" large :disabled="images.length >= max">
            <v-icon class="icon" style="opacity: .54;">mdi-image-multiple</v-icon><span style="margin-left: 8px">Select Images</span>
          </v-btn>
        </div>

      <input ref="inputImages" accept="image/*" style="pointer-events: none; width: 0; height: 0; opacity: 0;" type="file" :disabled="images.length >= max" class="image-button" multiple @change="imageChanged">
    </div>
          
    <div class="image-preview">

      <div v-for="(item, i) in images" :key="i">
        <div class="image-thumb" :style="{'background-image': 'url(' + item.uri + ')'}" @click="openGallery(i)">
          <v-btn color="error" class="remove-image" fab small @click="removeImage(i, $event)">
            <v-icon medium>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    
      <div class="clear"></div>
    </div>

  </div>
</template>

<script>

  import loadImage from 'blueimp-load-image-npm'

  export default {
    
    data () {
      return {
        images: []    
      }
    },

    props: {
      max: {
        default: 15
      }
    },

    computed: {
      
      cordova () {
        return window.cordova;
      },

      android () {
        return window.cordova && window.cordova.platformId === 'android';
      }
    },

    methods: {

      imageChanged (e) {
        var input = e.target;
        if (input.disabled) return alert('File upload not supported!');
        var F = this.$refs.inputImages.files;
        if (F && F[0]) for (var i = 0; i < F.length; i++) this.readImage(input.files[i]);
      },

      readImage (file) {

        var dataUrl = false;

        var orientation;
        loadImage.parseMetaData(file, (data) => {

          if (data.exif) orientation = data.exif.get('Orientation');
          else orientation = 1;

          var image = loadImage(file, (img) => {

            dataUrl = img.toDataURL('image/jpeg');

            var temp = {
              uri: dataUrl,
              w: image.width,
              h: image.height
            };

            this.images.unshift(temp);
          },
          {
            maxWidth: 1200,
            maxHeight: 900,
            canvas: true,
            orientation: orientation
          });

        if (!image) {
          Toast.show('Image upload failed.', 'error');
        }

        });
      },

      phonegapCamera () {
        if (!navigator || !navigator.camera) return;

        var destType = cordova.platformId === 'android' ? 1 : 2;
        navigator.camera.getPicture(
          function (result) {
            this.readImage(result);
          }.bind(this),

          function (e) {
            console.log('Camera Photo Error: ', e);
            if (e === 'No Image Selected') return;
            console.log('Image Camera Error:', e);
          }.bind(this),
          
          {
            destinationType: 1,
            encodingType: 0,
            correctOrientation: true
          }
        );
      },

    phonegapLibrary () {
      if (!navigator || !navigator.camera) return;

      var destType = cordova.platformId === 'android' ? 1 : 2;
      navigator.camera.getPicture(
        function (result) {
          result = result.replace("%", "%25");
          this.readImage(result);
        }.bind(this),
        function (e) {
          console.log('Camera Library Error: ', e);
          if (e === 'No Image Selected') return;
          console.log('Image Library Error: ', e);
        }.bind(this),
        {
          sourceType: 0,
          destinationType: 1,
          encodingType: 0,
          correctOrientation: (window.cordova.platformId === 'android')
        }
      );
    },

      openGallery (index) {
        Gallery.show(this.images, index);
      },

      removeImage(index, e) {      
        e.stopPropagation();
        this.images.splice(index, 1);
      },

      triggerImageUpload () {
        if (this.images.length >= this.max) return;
        this.$refs.inputImages.click();
      }

    }

  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #imageSelect {
    .image-section {
      position: relative;
      margin: 24px 0 0 40px;

      .image-icon {
        position: absolute;
        left: -39px;
        top: 10px;
      }

      .image-label {
        font-size: 12px;
        color: $black87;

        &.invalid {
          color: $error_red;
        }
      }
    }

    .buttons {
      .button {
        width: 50%;
        float: left;
      }
    }

    @media screen and (max-width: 480px) {
      
      .buttons {

        margin: 8px 0;
        
        .button {
          width: 100%;
          float: none;
          margin: 0 !important;
        }
      }
    }

    .image-preview {
      
      margin: 0 0 8px 40px;

      .image-thumb {
        position: relative;
        width: 115px;
        height: 115px;
        cursor: pointer;
        float: left;
        border: $borderBlack12;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        margin: 0 24px 8px 0;
      
        .remove-image {
          position: absolute;
          top: -26px;
          right: -28px;
        }
      }
    
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ImageSelect.vue